import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    _pixelInitialized: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Prevent duplicate initialization (especially in React Strict Mode)
    if (window._pixelInitialized) return;
    window._pixelInitialized = true;
    const timeoutId = setTimeout(() => {
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
      }
      // Initialize Pixel
      window.fbq('init', '1451684529949109');
      // Fire PageView
      window.fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1451684529949109&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return null;
}